var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 4.52973L13.47 3.46973L8.99997 7.93973L4.52997 3.46973L3.46997 4.52973L7.93997 8.99973L3.46997 13.4697L4.52997 14.5297L8.99997 10.0597L13.47 14.5297L14.53 13.4697L10.06 8.99973L14.53 4.52973Z",
    fill: "#4E5277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteX);
export default __webpack_public_path__ + "static/media/delete_x.4037d2a83b0cbfaeaf40e988066c3288.svg";
export { ForwardRef as ReactComponent };